import { render, staticRenderFns } from "./GroupDatiVendita.vue?vue&type=template&id=4fec9894&scoped=true"
import script from "./GroupDatiVendita.vue?vue&type=script&lang=ts"
export * from "./GroupDatiVendita.vue?vue&type=script&lang=ts"
import style0 from "./GroupDatiVendita.vue?vue&type=style&index=0&id=4fec9894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec9894",
  null
  
)

export default component.exports